var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level"},[_c('p',[_vm._v("難度：")]),_c('p'),_vm._l((5),function(index){return _c('div',{key:index,staticClass:"stars"},[_c('img',{attrs:{"src":_vm.level >= index ? _vm.stars.normal : _vm.stars.gray}})])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }